import { render, staticRenderFns } from "./AlertManagementPage.vue?vue&type=template&id=d3035226"
import script from "./AlertManagementPage.vue?vue&type=script&lang=js"
export * from "./AlertManagementPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports